import { InitialQueryState, SkipOrArgs } from '@common/types/queryState';
import { useAuthentication } from '@features/authentication';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { GetAccountsArgs } from '../types';
import { useUserAccounts } from './useUserAccounts';

export const useSelectedUserAccounts = (
    initialArgs: InitialQueryState = {},
) => {
    const {
        id: userId,
        isLoading: isUserDataLoading,
        isError: isUserDataError,
    } = useAuthentication();

    const queryArgs: SkipOrArgs<GetAccountsArgs> = useMemo(() => {
        if (!userId) return skipToken;
        return { userId };
    }, [userId]);

    const {
        isLoading: isAccountsLoading,
        isError: isAccoutnsError,
        ...queryResult
    } = useUserAccounts(initialArgs, queryArgs);

    return {
        ...queryResult,
        isLoading: isAccountsLoading || isUserDataLoading,
        isError: isAccoutnsError || isUserDataError,
    };
};
